<template>
  <v-row no-gutters class="login-dialog">
    <!-- <v-col cols="12" class="text-center">
      <input type="button" value="Say hello" @click="showAndroidToast()" style="width: 80%; height: 40px; border: 1px solid black; margin: 12px;" />
    </v-col> -->
    <v-row no-gutters class="loginGuideSection" v-if="showLoginGuide">
      <v-col class="pa-0" cols="11">
        <div class="d-flex align-center white--text">
          <img loading="lazy" src="/static/svg/icon_exit.svg" width="25" height="25" :contain="true" @click="closeShowLoginGuide()" />
          <label class="px-3">{{ $t(`label.loginGuide`) }} {{ $t(`label.clickThisButton`) }} {{ $t(`label.watchVideo`) }}</label>
        </div>
      </v-col>
      <v-col cols="1" class="pa-0 d-flex justify-center align-center">
        <v-img @click="closeShowLoginGuide()" src="/static/image/profile/closeIcon.png" width="15" height="15" :contain="true"></v-img>
      </v-col>
    </v-row>
    <v-col cols="12" :class="$vuetify.breakpoint.mdAndDown ? 'login_panel px-3 py-3' : 'login_panel px-3 py-3'">
      <v-form ref="loginForm">
        <app-form-field
          :enabledLabel="true"
          v-model.trim="loginObj.memberCode"
          :label="$t(`field.username`)"
          :placeholder="$t(`fieldHint.fillUpHere`)"
          :rules="validator.usernameRules()"
        ></app-form-field>
        <app-form-field
          :enabledLabel="true"
          v-model.trim="loginObj.password"
          :label="$t(`field.password`)"
          :placeholder="$t(`fieldHint.fillUpHere`)"
          :rules="validator.passwordRules()"
          :allowShowPassword="false"
          type="password"
        ></app-form-field>
        <v-row no-gutters>
          <v-col cols="12" class="text-right forgot-password">
            <v-btn text height="auto" @click="openForgotPasswordDialog" class="text-capitalize pr-0">
              {{ $t(`label.forgotPassword`) }}
            </v-btn>
          </v-col>
        </v-row>
        <!-- <app-button :action="this.login" :title="$t(`button.login`)"></app-button> -->
        <v-row no-gutters>
          <v-col cols="12">
            <v-btn height="auto" @click="this.login" class="button-primary full-width font-weight-bold">
              {{ $t(`button.login`) }}
            </v-btn>
            <!-- <button-primary
                :title="$t('button.login')"
                @action="this.login"
                :customClass="'full-width font-weight-bold'">
            </button-primary> -->
          </v-col>
          <v-col cols="12" class="text-center">
            <label v-show="loginErrorMsg" class="red--text subtitle-2">{{ loginErrorMsg }}</label>
          </v-col>
        </v-row>
      </v-form>
      <p class="mt-5 text-center subtitle-2">
        {{ $t(`message.dontHaveAccount`) }}
        <a class="link-underscore" @click="openRegister">{{ $t(`label.signUp`) }}</a>
      </p>
    </v-col>
  </v-row>
</template>

<script>
import stingFormat from 'string-format'
import { formValidator, uiHelper, errorCodeHelper } from '@/util'
import { SESSION, SHARED } from '@/constants/constants'
import { MEMBER_LOGIN } from '@/store/member.module'
import { ROUTE_NAME } from '../../constants/route.constants'

export default {
  name: 'appLogin',
  mounted() {
    this.$refs.loginForm.reset()
  },
  props: {
    closeAction: {
      type: Function,
      required: true,
      default: () => {}
    },
    openRegisterDialog: {
      type: Function,
      required: true,
      default: () => {}
    },
    openForgotPasswordDialog: {
      type: Function,
      required: true,
      default: () => {}
    },
    loginErrorMsg: {
      type: String,
      required: true,
      default: ''
    }
  },
  data: () => ({
    showLoginGuide: false,
    validator: formValidator,
    stingFormat: stingFormat,
    retainSignIn: false,
    loginObj: {
      memberCode: '',
      password: '',
      domain: '',
      platform: '',
      option: SHARED.DEFAULT_LOGIN_PASSWORD_METHOD,
      fbPixelId: '',
      fbp: uiHelper.getCookie(SESSION.FB_P),
      fbc: uiHelper.getCookie(SESSION.FB_C),
      channel_id: uiHelper.getCookie(SESSION.CHANNEL_ID)
    }
  }),
  computed: {
    isLoggedIn() {
      return this.$store.state.member.isLoggedIn
    }
  },
  watch: {
    isLoggedIn() {
      this.$refs.loginForm.reset()
    }
  },
  methods: {
    closeShowLoginGuide() {
      this.showLoginGuide = false
    },
    // showAndroidToast() {
    //   // AndroidFunction.isAndroid();
    //   // AndroidFunction.isMobile();
    //     // Android.showToast(toast);
    //     // Android.biometric();
    // },
    openRegister() {
      this.$refs.loginForm.reset()
      // this.openRegisterDialog()
      this.closeAction()
      this.$router.push({ name: ROUTE_NAME.REGISTER, params: { lang: this.$route.params.lang } })
    },
    login() {
      if (this.$refs.loginForm.validate()) {
        let jObj = this
        this.loginObj.domain = uiHelper.getHostname()
        this.loginObj.platform = uiHelper.getPlatform()
        this.loginObj.language = uiHelper.getLanguage()
        this.loginObj.fbPixelId = uiHelper.getCookie(SESSION.FB_PIXEL_CODE)
        this.loginObj.fbp = uiHelper.getCookie(SESSION.FB_P)
        this.loginObj.fbc = uiHelper.getCookie(SESSION.FB_C)
        this.loginObj.channel_id = uiHelper.getCookie(SESSION.CHANNEL_ID)
        let existFp = typeof uiHelper.getCookie('fp_visitor') != 'undefined' && uiHelper.getCookie('fp_visitor') != null && uiHelper.getCookie('fp_visitor') != ''
        if (existFp) {
          jObj.loginObj.fp = uiHelper.getCookie('fp_visitor')
          let loginObj = this.loginObj
          this.$store.dispatch(`${MEMBER_LOGIN}`, {
            loginObj
          })
        } else {
          try {
            jObj.loginObj.fp = uiHelper.getFingerprints()
            if (jObj.loginObj.fp != '' && jObj.loginObj.fp != null) {
              uiHelper.setCookie('fp_visitor', jObj.loginObj.fp, 30)
              let loginObj = jObj.loginObj
              this.$store.dispatch(`${MEMBER_LOGIN}`, {
                loginObj
              })
            }
          } catch (err) {
            console.log(err)
            let loginObj = this.loginObj
            this.$store.dispatch(`${MEMBER_LOGIN}`, {
              loginObj
            })
          }
        }
        // let loginObj = this.loginObj
        // this.$store.dispatch(`${MEMBER_LOGIN}`, {
        //   loginObj
        // })
        try {
          srtmCommands.push({
            event: 'track.user.login',
            payload: {
              action: 'complete',
              userId: this.loginObj.memberCode
            }
          })
          console.log('Sport Radar Login Completed!')
        } catch (err) {
          console.log(err)
        }
      }
    }
  }
}
</script>

<style lang="scss">
.watchNow {
  color: #322c44;
  background-color: #ffc000 !important;
}
.login-dialog {
  background: transparent linear-gradient(140deg, #3d3360 0%, #0f0a20 100%) 0 0 no-repeat padding-box;
}

.loginGuideSection {
  position: relative;
  padding: 12px;
  background: #221543;
  margin: 20px 12px !important;
}
.linkText {
  color: #ffffff !important;
}
.login_panel {
  color: #ffffff;
  background: transparent;

  .dialog-header {
    background: transparent linear-gradient(180deg, #1c1632 0%, #000000 100%) 0 0 no-repeat padding-box;
  }

  .link-underscore {
    text-decoration: underline;
    color: var(--v-primary-base);
  }

  .forgot-password {
    margin-bottom: 12px;
    color: white;

    .theme--dark.v-btn {
      color: white;
    }

    .v-btn {
      color: white;
    }

    .v-btn:hover {
      text-decoration: underline;
      color: var(--v-primary-base);
      cursor: pointer;
    }

    .v-btn::before {
      color: white;
      background-color: unset;
    }
  }
}
</style>
